import Billing from "./Billing";
import { showAlert } from "helper";
import styled from "styled-components";
import UsersContent from "./UsersContent";
import TeamsContent from "./TeamsContent";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { getRolesApi } from "services/get/getRoles";
import { getTeamsApi } from "services/get/getTeamsApi";
import { getUserDataApi } from "services/get/getUserDataApi";
import { deleteTeamsApi } from "services/post/deleteTeamsApi";

const Wrapper = styled.div`
  margin: 15px 0;
  padding: 1rem 1rem;
  font-size: 14px;
  line-height: 19px;
  color: #ffffff;

  label {
    font-size: 10px;
    background-color: #353535 !important;
  }

  input {
    font-size: 14px !important;
  }
`;

const Tabs = styled.div`
  margin-bottom: 30px;

  button {
    padding-bottom: 5px;
    font-weight: 700;
    font-size: 15px;
    line-height: 19px;
    font-family: Roboto;
    color: #a0a0a0;
    outline: none;

    &:not(:first-child) {
      margin-left: 22px;
    }

    &.active {
      color: #e5e5e5;
      border-bottom: solid 2px #487bf2;
    }
  }
`;

const AccountAdmin = () => {
  const [tab, setTab] = useState("teams");
  const [teams, setTeams] = useState([]);
  const [roles, setRoles] = useState([]);
  const [userData, setUserData] = useState([]);
  const profile = useSelector(state => state.profile.profile);

  const setActiveTab = (tab) => () => {
    setTab(tab);
  };

  const getTeams = async () => {
    const org_id = profile.organizations[0].id;
    const response = await getTeamsApi(org_id);
    
    if (response && response?.status === 200) {
      setTeams(response.data);
    }
  };

  const getRoles = async () => {
    const response = await getRolesApi();
    
    if (response && response?.status === 200) {
      setRoles(response.data);
    }
  };

  const getUserData = async () => {
    const org_id = profile.organizations[0].id;

    const response = await getUserDataApi(org_id);
    if (response && response?.status === 200) {
      setUserData(response.data);
    }
  };

  const deleteTeamsFunction = async (selectedTeamIDs) => {
    if (selectedTeamIDs.length === 0) {
      showAlert('error', 'Please select teams to delete.')
    } else {
      const response = await deleteTeamsApi(selectedTeamIDs);
      if (response && response.status === 200) {
        const teamsNew = teams.filter(
          ({ id }) => !selectedTeamIDs.includes(id)
        );
        setTeams(teamsNew);
        showAlert('success', 'Selected teams are succesfully deleted.')
      }
    }
  };

  const addTeamFunction = (newData) => {
    setTeams((oldArray) => [...oldArray, newData]);
  };

  useEffect(() => {
    if (profile && profile.organizations && profile.organizations[0]) {
      getTeams();
      getRoles();
      getUserData();
    }
  }, [profile]);

  return (
    <Wrapper>
      <Tabs>
        <button className={tab === "teams" ? "active" : null} onClick={setActiveTab("teams")}>
          Teams
        </button>
        <button className={tab === "users" ? "active" : null} onClick={setActiveTab("users")}>
          Members
        </button>
        <button className={tab === "billing" ? "active" : null} onClick={setActiveTab("billing")}>
          Billing
        </button>
      </Tabs>
      {tab === "teams" && (<TeamsContent deleteTeamsFunction={deleteTeamsFunction} addTeamFunction={addTeamFunction} teams={teams} roles={roles} />)}
      {tab === "users" && (<UsersContent teams={teams} roles={roles} data={userData} />)}
      {tab === "billing" && (<Billing />)}
    </Wrapper>
  );
};

export default AccountAdmin;